import { TOKEN_KEY, storageEngine } from 'utilities/integration/rails';

export const getLocalToken = () => storageEngine.getItem(TOKEN_KEY);

export default getLocalToken;
